// extracted by mini-css-extract-plugin
export var infoItem = "_k1-1";
export var title = "_k1-0";